import { Component } from "@angular/core";

@Component({
    selector: 'app-pagenotfound',
    styleUrls: ['pagenotfound.component.scss'],
    templateUrl: 'pagenotfound.component.html',
})
export class PageNotFoundComponent {
    // message = `Sorry, the page you're looking for doesn't exist. If you think something is broken, report a problem.`
    message = `Sorry, the page you're looking for doesn't exist`;
}


// WEBPACK FOOTER //
// ./src/app/pagenotfound/pagenotfound.component.ts